import FileSaver from 'file-saver';

export class DownloaderHelper {
    public static forceDownload(blob: Blob, originalName: string): void {
        FileSaver.saveAs(blob, originalName);
    }
}
